export enum MY_HOUSE_NOTICE_CATEGORY {
  ALL = 'ALL',
  OFFICE = 'OFFICE',
  MEETING = 'MEETING',
  TENANT = 'TENANT',
  GOVERNMENT = 'GOVERNMENT',
  ETC = 'ETC',
}

export const MY_HOUSE_NOTICE_CATEGORY_OBJ = {
  [MY_HOUSE_NOTICE_CATEGORY.ALL]: {
    CODE: MY_HOUSE_NOTICE_CATEGORY.ALL,
    ENROLL_LABEL: '전체글',
    SUMMARY_LABEL: '전체글',
    LABEL: '전체 공지사항',
  },
  [MY_HOUSE_NOTICE_CATEGORY.OFFICE]: {
    CODE: MY_HOUSE_NOTICE_CATEGORY.OFFICE,
    ENROLL_LABEL: '관리사무소',
    SUMMARY_LABEL: '관리사무소',
    LABEL: '관리사무소 공지사항',
  },
  [MY_HOUSE_NOTICE_CATEGORY.MEETING]: {
    CODE: MY_HOUSE_NOTICE_CATEGORY.MEETING,
    ENROLL_LABEL: '입주자 대표 회의',
    SUMMARY_LABEL: '입주자 대표 회의',
    LABEL: '입주자 대표 회의 공지사항',
  },
  [MY_HOUSE_NOTICE_CATEGORY.TENANT]: {
    CODE: MY_HOUSE_NOTICE_CATEGORY.TENANT,
    ENROLL_LABEL: '입주민공지',
    SUMMARY_LABEL: '입주민',
    LABEL: '입주민 공지사항',
  },
  [MY_HOUSE_NOTICE_CATEGORY.GOVERNMENT]: {
    CODE: MY_HOUSE_NOTICE_CATEGORY.GOVERNMENT,
    ENROLL_LABEL: '지자체공지',
    SUMMARY_LABEL: '지자체',
    LABEL: '지자체 공지사항',
  },
  [MY_HOUSE_NOTICE_CATEGORY.ETC]: {
    CODE: MY_HOUSE_NOTICE_CATEGORY.ETC,
    ENROLL_LABEL: '기타공지',
    SUMMARY_LABEL: '기타',
    LABEL: '기타 공지사항',
  },
}

export const MY_HOUSE_NOTICE_CATEGORY_LIST = [
  MY_HOUSE_NOTICE_CATEGORY_OBJ.ALL,
  MY_HOUSE_NOTICE_CATEGORY_OBJ.OFFICE,
  MY_HOUSE_NOTICE_CATEGORY_OBJ.MEETING,
  MY_HOUSE_NOTICE_CATEGORY_OBJ.TENANT,
  MY_HOUSE_NOTICE_CATEGORY_OBJ.GOVERNMENT,
  MY_HOUSE_NOTICE_CATEGORY_OBJ.ETC,
]

export enum MY_HOUSE_AUTH_TYPE {
  NORMAL = '우리집등록',
  OWNER = '소유자인증',
  RESIDENT = '입주민인증',
  BOTH = '소유자/입주민인증',
}

export enum MY_HOUSE_AUTH_STATUS {
  COMPLETE = '인증완료',
  PROGRESS = '인증진행중',
  NOT_AUTH = '인증미신청',
}

export enum MY_HOUSE_AUTH_METHOD {
  CERTIFICATE_OF_REALESTATE_REGISTER = 'CRER',
  PACKAGE = 'PACK',
  MANAGEMENT_FEE = 'MNEX',
  PURCHASE_DECISION = 'NPAY',
}

export enum MY_HOUSE_BOARD_TYPE {
  NOTICE = 'NOTICE',
  REVIEW = 'REVIEW',
}

export const MY_HOUSE_BOARD_TYPE_OBJ = {
  [MY_HOUSE_BOARD_TYPE.NOTICE]: {
    CODE: MY_HOUSE_BOARD_TYPE.NOTICE,
    LABEL: '공지사항',
  },
  [MY_HOUSE_BOARD_TYPE.REVIEW]: {
    CODE: MY_HOUSE_BOARD_TYPE.REVIEW,
    LABEL: '리뷰',
  },
}

export enum MY_HOUSE_BOARD_WRITING_TYPE {
  ENROL = 'NOTICE',
  MODIFY = 'REVIEW',
}

export enum DUPLICATE_STATUS_TYPE {
  COMPLEX_SEQ_DUP = 'COMPLEX_SEQ_DUP',
  COMPLEX_NAME_DUP = 'COMPLEX_NAME_DUP',
  BASE_ADDR_DUP = 'BASE_ADDR_DUP',
  NO_DUP = 'NO_DUP',
}

export enum REAL_ESTATE {
  APART = 'APT',
  REBUILD = 'JGC',
  APART_RIGHT = 'ABYG',
  OFFICETEL = 'OPST',
  OFFICETEL_RIGHT = 'OBYG',
  VILLA = 'VL',
  HOUSE = 'DDDGG',
  COUNTRY_HOUSE = 'JWJT',
  STORE_HOUSE = 'SGJT',
  HANOK_HOUSE = 'HOJT',
  GROUND = 'TJ',
  ONEROOM = 'OR',
  STORE = 'SG',
  OFFICE = 'SMS',
  FACTORY = 'GJCG',
  INDUSTRY_CENTER = 'APTHGJ',
  REDEVELOP = 'JGB',
  BUILDING = 'GM',
}

export const REAL_ESTATE_TYPE_OBJ: Record<
  REAL_ESTATE,
  {
    LABEL: string
    CODE: REAL_ESTATE
    NCLICK: string
  }
> = {
  [REAL_ESTATE.APART]: { LABEL: '아파트', CODE: REAL_ESTATE.APART, NCLICK: 'FAA.apt' },
  [REAL_ESTATE.REBUILD]: { LABEL: '재건축', CODE: REAL_ESTATE.REBUILD, NCLICK: 'FAA.reconstruction' },
  [REAL_ESTATE.APART_RIGHT]: { LABEL: '아파트분양권', CODE: REAL_ESTATE.APART_RIGHT, NCLICK: 'FAA.aptsale' },
  [REAL_ESTATE.ONEROOM]: { LABEL: '원룸', CODE: REAL_ESTATE.ONEROOM, NCLICK: 'FAA.oneroom' },
  [REAL_ESTATE.OFFICETEL]: { LABEL: '오피스텔', CODE: REAL_ESTATE.OFFICETEL, NCLICK: 'FAA.officetel' },
  [REAL_ESTATE.OFFICETEL_RIGHT]: { LABEL: '오피스텔분양권', CODE: REAL_ESTATE.OFFICETEL_RIGHT, NCLICK: 'FAA.offsale' },
  [REAL_ESTATE.VILLA]: { LABEL: '빌라/연립', CODE: REAL_ESTATE.VILLA, NCLICK: 'FAA.villa' },
  [REAL_ESTATE.HOUSE]: { LABEL: '단독/다가구', CODE: REAL_ESTATE.HOUSE, NCLICK: 'FAA.mhouse' },
  [REAL_ESTATE.COUNTRY_HOUSE]: { LABEL: '전원주택', CODE: REAL_ESTATE.COUNTRY_HOUSE, NCLICK: 'FAA.chouse' },
  [REAL_ESTATE.STORE_HOUSE]: { LABEL: '상가주택', CODE: REAL_ESTATE.STORE_HOUSE, NCLICK: 'FAA.shouse' },
  [REAL_ESTATE.HANOK_HOUSE]: { LABEL: '한옥주택', CODE: REAL_ESTATE.HANOK_HOUSE, NCLICK: 'FAA.hhouse' },
  [REAL_ESTATE.GROUND]: { LABEL: '토지', CODE: REAL_ESTATE.GROUND, NCLICK: 'FAA.ground' },
  [REAL_ESTATE.STORE]: { LABEL: '상가', CODE: REAL_ESTATE.STORE, NCLICK: 'FAA.shop' },
  [REAL_ESTATE.OFFICE]: { LABEL: '사무실', CODE: REAL_ESTATE.OFFICE, NCLICK: 'FAA.office' },
  [REAL_ESTATE.FACTORY]: { LABEL: '공장/창고', CODE: REAL_ESTATE.FACTORY, NCLICK: 'FAA.office' },
  [REAL_ESTATE.INDUSTRY_CENTER]: { LABEL: '지식산업센터', CODE: REAL_ESTATE.INDUSTRY_CENTER, NCLICK: 'FAA.afactory' },
  [REAL_ESTATE.REDEVELOP]: { LABEL: '재개발', CODE: REAL_ESTATE.REDEVELOP, NCLICK: 'FAA.renewal' },
  [REAL_ESTATE.BUILDING]: { LABEL: '건물', CODE: REAL_ESTATE.BUILDING, NCLICK: 'FAA.building' },
}

export const BOARD_TITLE_MAX_LENGTH = 40
export const BOARD_CONTENT_MAX_LENGTH = 1000
export const BOARD_IMAGE_MAX_COUNT = 20
export const BOARD_IMAGE_MAX_MB_SIZE = 30
export const AUTHENTICATION_IMAGE_MAX_MB_SIZE = 5
export const AUTHENTICATION_MAX_COUNT = 2
